import { AuctionField } from 'components/ListVehicles/components/CreateVehicleDialog/AuctionField';
import { SellerField } from 'components/ListVehicles/components/CreateVehicleDialog/SellerField';
import { VinField } from 'components/ListVehicles/components/CreateVehicleDialog/VinField';
import { useCurrentUser } from 'hooks/selectors';
import { useGetSellersQuery } from 'services/api';
import styled from 'styled-components';
import { VehicleActions } from '../VehicleActions';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
`;

export const VinInfoTab = () => {
  const user = useCurrentUser();

  const { data: users = [] } = useGetSellersQuery(undefined, {
    skip: user.role !== 'admin'
  });

  const userOptions = users.map(u => ({
    value: u.id,
    label: u.dealership_name
  }));

  return (
    <Wrapper>
      {user.role === 'admin' && <SellerField userOptions={userOptions} />}
      <VinField type={'edit'} />
      {user.role === 'admin' && <AuctionField />}
      <div style={{ flex: 1 }} />
      <VehicleActions />
    </Wrapper>
  );
};
